'use strict';

import $ from 'jquery';
// import mpro from './mpro.init';

// == Error handler ==
mpro.handleError = function (context, err_handler, err_type, err) {

	if (err_handler === 'display') {
		// Display the error
		mpro.displayError(context, err_type, err);
	}
	else if (err_handler === 'form') {
		mpro.formError(context, err_type, err);
	}
	else {
		// TODO
	}
};

// == Display error handler ==
mpro.displayError = function (context, err_type, err) {

	// Assume we have an assoc array of errors
	var err_msg = [];
	var title = String(err_type);

	// Response object error
	if (err_type === 'response_error') {
		$.each([].concat(err), function (i, v) {
			err_msg.push(v);
		});
	}
	// Response resp invalid
	else if (err_type === 'invalid_response') {
		err_msg.push('Invalid remoteAction response');
	}
	// Response resp invalid
	else if (err_type === 'xhr_error') {
		title = (err.jqXHR) ? String(err.jqXHR.status) : title;
		// err_msg.push('<h4>Whoops! Something went wrong!</h4><div>' + err.errorThrown + '</div>');
		err_msg.push(mpro.langvar('error_unknown'));
	}
	// Other type of error
	else {
		err_msg.push('Whoops! Something went wrong!');
	}

	var contextTitle;

	if (context) {
		var $context = $(context);
		contextTitle = $context.attr('title');
		if (contextTitle) {
			title = contextTitle;
		}
	}

	if (!contextTitle) {
		title = 'Error (' + (title.replace(/_/ig, ' ').replace(/^\w/, function (v) { return String(v[0]).toUpperCase(); })) + ')';
	}

	mpro.alert({
		title: title,
		message: err_msg.join('<br />'),
	});
};

// == Form error handler ==
mpro.formError = function (context, err_type, resp) {
	// TODO
};

export default mpro;
